// extracted by mini-css-extract-plugin
export default {"container":"DevelopVersionInfo_container__ajJmm","table":"DevelopVersionInfo_table__fSB85"};